module.exports = __webpack_public_path__ + "blissweb-bd.95078aa341d4682ccd81.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Bd/blissweb-bd.ttf
// module id = 474
// module chunks = 5